import SideTool from '@/global/components/side-tool'
import './index.less'
import { useContext, useEffect, useRef, useState } from 'react'
import { useLocation, useParams } from 'react-router'
import { MonitorObject } from '@/global/interface/monitor-object/monitor-object';
import { getMonitorObjectWithParamsByProjectId } from '@/api/monitor-object/monitor-object';
import TnMessage from '@/global/components/message';
import MonitorObjectItem from './monitor-object-item/item';
import { MONITOR_PARAMETER_TYPE } from '@/enums/monitor-parameter-type';
import { getGlobalMonitorParameters } from '@/api/lib/lib-monitor-parameter';
import { GlobalMonitorParameter } from '@/global/interface/lib-device/global-monitor-parameter';
import { Emit_Event } from '@/enums/emit-event';
import { emitter } from '@/global/listeners';
import { SideStatus } from '@/global/store/side-store';
import { SideContext } from '@/App';
import { Skeleton } from 'antd';

// 监测对象侧边栏
export default function MonitorObjectPanel() {
    const location = useLocation(); // 路由
    const { projectId } = useParams();// 路由参数，项目id
    const [list, setList] = useState<MonitorObject[]>([]); // 监测对象列表
    const [globalParameters, setGlobalParameters] = useState<GlobalMonitorParameter[]>([]); // 全局监测参数-间接
    const listRef = useRef(list);
    const sideContext = useContext<SideStatus>(SideContext);
    const [activeItemId, setActiveItemId] = useState<number>(); // 激活的监测对象
    const [activeParamId, setActiveParamId] = useState<number>(); // 激活的监测参数
    const [loading, setLoading] = useState<boolean>(); // 加载状态
    const [replaceId, setReplaceId] = useState<number>(); // 当前正在重选监测对象图元的对象id

    useEffect(() => {
        sideContext.setSelectedPanelValue("monitor-object");
        if (!projectId) return;
        generateData();
        emitter.on(Emit_Event.ADD_MONITOR_OBJECT_FINISH, onAddObjectFinish)
        return (() => {
            emitter.off(Emit_Event.ADD_MONITOR_OBJECT_FINISH, onAddObjectFinish)
        })
    }, [projectId]) // 项目id变化时，获得监测对象列表


    // 监听路由，高亮左侧列表
    useEffect(() => {
        let pathName = location.pathname;

        const match = pathName.match(/\/bim\/project\/\d+\/monitor-object\/(\d+)/);
        if (match) {
            const id = match[1];
            setActiveItemId(+id);
        } else {
            setActiveItemId(null);
        }
        const matchParam = pathName.match(/\/bim\/project\/\d+\/monitor-parameter\/(\d+)/);
        if (matchParam) {
            const id = matchParam[1];
            setActiveParamId(+id);
        } else {
            setActiveParamId(null);
        }
    }, [location.pathname])

    useEffect(() => {
        // 获得全局参数中的间接参数，添加参数时作为可选项
        getGlobalMonitorParameters({ type: MONITOR_PARAMETER_TYPE.INDIRECT }).then(res => {
            let dataList: GlobalMonitorParameter[] = res.data || [];
            setGlobalParameters(dataList);
        }).catch(() => {
            TnMessage.error("获得全局参数失败");
        })
    }, [])

    useEffect(() => {
        listRef.current = list;
    }, [list]);

    // 根据项目id获得监测对象列表，含根监测参数
    const generateData = () => {
        setLoading(true);
        getMonitorObjectWithParamsByProjectId(+projectId).then(res => {
            let list: MonitorObject[] = res.data || [];
            setList(list);
        }).catch(err => {
            if (err.data) {
                TnMessage.error(err.data);
            } else {
                TnMessage.error("获得监测对象列表失败")
            }
        }).finally(() => {
            setLoading(false);
        })
    }

    // 添加监测对象完成
    const onAddObjectFinish = (item) => {
        if(item && !item.rootMonitorParameters){
            item.rootMonitorParameters = [];
        }
        setList([...listRef.current, item]);
    }
    
    return (
        <div className="monitor-object-side-container">
            <SideTool />
            <div className="list-main">
                <Skeleton loading={loading}>
                    {list.map((item, index) => (
                        <MonitorObjectItem key={index} monitorObject={item} globalParameters={globalParameters} active={activeItemId == item.id} activedParamId={activeParamId}
                            onDeleteObject={() => {
                                let newList = [...list];
                                newList.splice(index, 1);
                                setList([...newList]);
                            }}
                            replaceId={replaceId}
                            onSetReplaceId={(value)=>{
                                setReplaceId(value)
                            }}
                        />
                    ))}
                </Skeleton>
            </div>
        </div>
    )
}